var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LoginCard",
    { attrs: { "data-test-id": "UserLogin__PasswordEntry" } },
    [
      _c("h1", { class: _vm.$style.header }, [_vm._v("\n    User Login\n  ")]),
      _vm._v(" "),
      _vm.form.email
        ? _c(
            "EmailBadge",
            { attrs: { email: _vm.form.email } },
            [
              _c("template", { slot: "badgeAction" }, [
                _c(
                  "button",
                  {
                    class: _vm.$style.actionLink,
                    attrs: { "data-test-id": "badgeActionButton" },
                    on: { click: _vm.handleComponentChange },
                  },
                  [_vm._v("\n        Change\n      ")]
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "LoginAlert",
        {
          attrs: { centered: "" },
          model: {
            value: _vm.errorMessage,
            callback: function ($$v) {
              _vm.errorMessage = $$v
            },
            expression: "errorMessage",
          },
        },
        [
          _vm.errorMessage
            ? _c("div", [
                _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n      "),
                _c("div", [
                  _c("span", [_vm._v("Are you trying to ")]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      class: _vm.$style.swapClientTypeLink,
                      attrs: {
                        "data-test-id": "UserLogin__PasswordEntry__adminLink",
                      },
                      on: { click: _vm.goToAdminLogin },
                    },
                    [
                      _vm._v(
                        "\n          log in as an Administrator?\n        "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "form",
        { attrs: { action: _vm.submit, autocomplete: "on", method: "post" } },
        [
          _c("LoginTextField", {
            attrs: {
              autoFocus: "",
              label: "Password",
              name: "password",
              placeholder: "Password",
              required: "",
              submitOnEnter: _vm.submit,
              type: "password",
              vvName: "password",
            },
            model: {
              value: _vm.form.password,
              callback: function ($$v) {
                _vm.$set(_vm.form, "password", $$v)
              },
              expression: "form.password",
            },
          }),
          _vm._v(" "),
          _c(
            "LoginActionButton",
            {
              attrs: {
                action: _vm.submit,
                "data-automation": "loginButton",
                isLoading: _vm.isLoading,
                type: "submit",
              },
            },
            [_vm._v("\n      Login\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$style.resetPassword,
          attrs: {
            "data-test-id": "UserLogin__PasswordEntry__resetPasswordLink",
          },
        },
        [
          _c(
            "span",
            {
              class: _vm.$style.resetPasswordLink,
              on: { click: _vm.resetPasswordRequest },
            },
            [_vm._v("\n      Reset User Password\n    ")]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }